import React, { useState } from "react";
import { toast } from "react-toastify";
import { API_ENDPOINT, HEADER_TOKEN } from "../../constants/constants";
import axios from "axios"

const TopUp = ({ user }) => {
  const [ac, setAc] = useState("");
  const [loading, setLoading] = useState(false);

  const addTopUp = () => {
    if (ac === "") {
      toast("Please Enter Candidate count", { position: 'bottom-center', autoClose: 1000 })
      return
    }
    setLoading(true)
    // Wire field stays `assessmentCount` — the API keeps it as a synced legacy
    // alias for the candidate count.
    axios.post(API_ENDPOINT + 'admin/trainer-topup', { phone: user.phone, assessmentCount: ac }, HEADER_TOKEN).then(res => {
      setLoading(false)
      let d = res.data
      if (d.success) setAc("");
      toast(d.message, { autoClose: 900, position: 'top-right' })
    }).catch(() => { setLoading(false); toast("Request failed", { autoClose: 900, position: 'top-right' }) })
  }

  return (
    <div style={{ maxWidth: 600, margin: "auto" }}>
      <div style={{ display: 'grid', gridTemplateColumns: 'auto 1fr', gap: '8px 18px', fontSize: 14, marginBottom: 18 }}>
        <div className="text-muted">Name</div>
        <div style={{ fontWeight: 600 }}>{user && user.name}</div>
        <div className="text-muted">Plan</div>
        <div style={{ fontWeight: 600 }}>{user && user.plan && user.plan.name}</div>
        <div className="text-muted">Status</div>
        <div>
          {user && user.plan
            ? <span className={user.plan.status === "Expired" ? "tag tag-neutral" : "tag tag-accent"}>{user.plan.status}</span>
            : <span className="tag tag-neutral">—</span>}
        </div>
      </div>

      <hr className="hr" />

      <div style={{ display: 'flex', alignItems: 'flex-end', gap: 10 }}>
        <div className="field" style={{ flex: 1 }}>
          <label>Candidate Count</label>
          <input
            className="input"
            value={ac}
            onChange={(e) => { if (/^\d*$/.test(e.target.value)) setAc(e.target.value) }}
            placeholder="e.g. 100"
          />
        </div>
        <button className="btn btn-primary" onClick={addTopUp} disabled={loading} style={{ minHeight: 36 }}>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14" /><path d="M12 5v14" /></svg>
          {loading ? 'Adding…' : 'Top Up'}
        </button>
      </div>
    </div>
  );
};

export default TopUp;
